import socketServer from "../sources/SocketServer";
import Cookies from "js-cookie";

class WorkersController {
    async registerWorker(url, scope = "/") {
        if (!('serviceWorker' in navigator)) {
            return console.warn("This browser don't support Service Workers.")
        }

        try {
            const worker = await navigator.serviceWorker.register(url, {scope});
            console.log("Service worker was registered:", worker.scope);

            worker.addEventListener("updatefound", () => {
                if (worker.installing) {
                    worker.installing.addEventListener('statechange', () => {
                        if (worker.waiting) {
                            if (navigator.serviceWorker.controller) {
                                worker.waiting.postMessage('SKIP_WAITING');
                            } else {
                                console.log('Service Worker initialized for the first time')
                            }
                        }
                    })
                }
            });
        } catch (e) {
            console.error(e);
        }
    }

    async addMessagesListener() {
        navigator.serviceWorker.addEventListener('message', this.onMessage);
    }

    onMessage(event) {
        switch (event.data.command) {
            case "clearAuthCookie":
                Cookies.remove("isAuthorized");
                break;
            case "closeSocketConnection":
                socketServer.closeConnection();
                break;
            case "reload":
                window.location.reload();
                break;
            case "navigate":
                window.location.pathname = event.data.pathname;
                break;
            default:
                console.log("Unknown event command");
        }
    }
}

export default new WorkersController();


// WEBPACK FOOTER //
// ./src/store/WorkersController.js